


























































































import Vue from 'vue'

import PointsList from '@/components/PointsList.vue'
import TablesPanel from '@/components/TablesPanel.vue'
import ImagesPanel from '@/components/ImagesPanel.vue'
import Infos from '@/components/Infos.vue'
import Home from '@/components/Home.vue'

export default Vue.extend({
  name: 'App',
  data: () => ({
    small: 600,
    big: 6000,
    barWidth: 600,
    drawer: false,
    view: 'points'
  }),
  mounted: function () {
    this.small = this.$vuetify.breakpoint.thresholds.md * 0.5
    this.barWidth = this.small
  },
  components: {
    PointsList,
    TablesPanel,
    ImagesPanel,
    Infos,
    Home
  },
  computed: {
    viewTitle: function () {
      const titles: Map<string, string> = new Map([
        ['tables', 'Data Tables'],
        ['images', 'Background Image'],
        ['points', 'Points']
      ])
      return titles.get(this.view) || ''
    }
  },
  methods: {
    toggleFullscreen: function () {
      if (this.barWidth === this.small) {
        this.barWidth = this.big
      } else {
        this.barWidth = this.small
      }
    }
  }
})
